import { render, staticRenderFns } from "./NotesListTab.vue?vue&type=template&id=47bab557&scoped=true&"
import script from "./NotesListTab.vue?vue&type=script&lang=js&"
export * from "./NotesListTab.vue?vue&type=script&lang=js&"
import style0 from "./NotesListTab.vue?vue&type=style&index=0&id=47bab557&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bab557",
  null
  
)

export default component.exports